import store from '../store/store.js';
import axios from '../axios';
import url from '@/services/urlService.js';

const NOT_LOGGED_IN   = 0;
const REQUIRES_RELOAD = 1;
const LOGGED_IN       = 2;


const parseJwt = token => {
  try {
    let parsedJwt = {}

    parsedJwt = JSON.parse(atob(token.split('.')[1]));
    return {
      token: token,
      expiry: new Date(parsedJwt.exp * 1000)
    }
  } catch (e) {
    return {}
  }
}

const getStoredAccessToken = () => {
  if (typeof localStorage.accessToken === 'undefined') {
    console.log('not in localStorage');
    console.log(localStorage);
    let cookies = getCookies();
    if (typeof cookies.iat === 'undefined') {
      return '';
    }

    return cookies.iat;
  }

  return localStorage.accessToken;
}

const getLoginStatus = () => {
  const now = new Date();

  if (store.state.auth.tokenExpiry instanceof Date) {
    return store.state.auth.tokenExpiry > now ? 2: 0; 
  } 

  let iat = getStoredAccessToken();
  let jwt = parseJwt(iat);
  if (jwt === null) {
    return 0;
  }

  if (jwt.expiry instanceof Date) {
    return jwt.expiry > now ? 1 : 0
  }

  return 0;
}

const reloadLogin = async () => {
  return new Promise((resolve, reject) => {
    store.dispatch('auth/reloadLogin').then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
}

const signup = (email, password) => {
  return new Promise((resolve, reject) => {
    store.dispatch('auth/signup', {
      email: email, 
      password: password
    }).then(() => {
      resolve();
    }).catch(error => {
      reject(error);
    });
  });
}

const login = (email, password, remember_me ) => {
  return new Promise((resolve, reject) => {
    store.dispatch('auth/login', {
      email: email,
      password: password
    }).then((response) => {
      resolve(response);
    }).catch( error => {
      reject(error);
    });
  });
}

const getOnboardStep = async () => {
  let step = await store.state.user.onboard_step;

  if (typeof step === 'undefined') {
    step = 1;
  }

  return step;
}

const verifyCode = (code) => {
  return new Promise((resolve, reject) => {
    store.dispatch('auth/verify', code).then(response => {
      resolve(response);
    }).catch(e => {
      reject(e);
    })
  })
}

const resendVerificationCode = (user_id) => {
  return new Promise((resolve, reject) => {
    axios.patch('/user/verification')
      .then(res => {
        resolve(res);
      }).catch(error => {
        reject(error);
      });
  })
}

const getCookies = () => {
  return document.cookie.split(';').reduce((dic, cur) => {
    let [key, val] = cur.split('=');
    dic[key] = val;
    return dic;
  }, {});
}

const setAccessTokenInCookie = (accessToken) => {
  let oneHour = 60 * 60;
  let domain  = url.rootDomain();

  document.cookie = `iat=${accessToken}; domain=${domain}; max-age=${oneHour}`;
}

export default {
  NOT_LOGGED_IN,
  REQUIRES_RELOAD,
  LOGGED_IN,

  getLoginStatus,
  getOnboardStep,
  login,
  reloadLogin,
  signup,
  verifyCode,
  resendVerificationCode,
  setAccessTokenInCookie,
  getStoredAccessToken
}
